/* oxlint-disable */
import { css } from 'lit';

export default css`:host {
  display: block;
  width: 100%;
  --_container-height: var(--page-height, auto);
  --_container-padding: 0;
  --_text-color: light-dark(oklch(0% 0 0deg), oklch(100% 0 0deg));
  --_shadow-color: light-dark(oklch(100% 0 0deg), oklch(0% 0 0deg));
}
:host .progress-container--extent-area {
  --_container-padding: 0.5rem;
  --_container-height: auto;
}

.progress-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: var(--_container-padding);
  height: var(--_container-height);
}

.progress-container--extent-full {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.progress-container--extent-full > * {
  width: 100%;
  max-width: 87.5rem;
}

.progress-container__text {
  font-size: 1.5rem;
  color: var(--_text-color);
  text-shadow: 0 0 12px var(--_shadow-color);
  padding: 0.5rem;
  background: oklch(14.5% 0 0deg / 0.75);
  border-radius: 6px;
  text-align: center;
  width: auto;
}`;
